<template>
  <v-row
    no-gutters
    class="elevation-1 px-4 elevation-1 pa-4 bordered-row">
    <v-col cols="4">
      <img
        :src="images.length ? $convertImgix(`${images[0]}?w=1024`) : noPicture"
        style="width: 120px;"
        class="rounded elevation-3 my-1" />
    </v-col>
    <v-col cols="4">
      <h4 class="product-name subtitle-1 font-weight-bold">
        {{ name }}
      </h4>
      <p class="mb-0 text-body-2">
        <span class="text-bold">รหัสสินค้า :</span> {{ code }}
      </p>
      <p class="mb-0 text-body-2 text-uppercase">
        <span class="text-bold">ขนาด :</span> {{ size }}
      </p>
      <p class="mb-0 text-body-2 text-uppercase">
        <span class="text-bold">สี :</span> {{ color }}
      </p>
      <p
        v-if="isShowFit"
        class="mb-0 text-body-2 text-uppercase">
        <span class="text-bold">Fit : </span>
        <span
          v-if="fitting === 'FIT : -' || !fitting"
          class="red--text">ไม่ระบุ
        </span>
        <span v-else>{{ fitting }}</span>
      </p>
      <p class="mb-0 text-body-2">
        <span class="text-bold">คอลเลคชั่น :</span> {{ collection === 'COLLECTION : -' || !collection ? '-' : collection }}
      </p>
      <p class="mb-0 text-body-2">
        <span class="text-bold">สถานที่ผลิต : </span>
        <span v-if="manufacCountry">
          {{ manufacCountry.toLocaleUpperCase() }}
        </span>
        <span
          v-else
          class="red--text">ไม่ระบุข้อมูล</span>
      </p>
    </v-col>
    <v-col cols="4">
      <v-simple-table
        dense
        class="bordered-table mb-4">
        <thead>
          <tr>
            <th class="text-left">
              Currency
            </th>
            <th class="text-right">
              Price
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>THB</td>
            <td class="text-right">
              {{ price | showNumberFormat() }}
            </td>
          </tr>
          <tr
            v-for="(currency, index) in currencies"
            :key="`currency-${index}`"
          >
            <td>{{ currency.currency }}</td>
            <td
              v-if="currency.priceFromMapping"
              class="text-right">
              {{ currency.price | showNumberFormat() }}
            </td>
            <td
              v-else
              class="text-right">
              {{ showPriceLocale(currency.price, currency.locale, currency.currency).price }}
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-col>
    <v-col
      v-if="isShowQty"
      cols="12">
      <div class="d-flex flex-row justify-space-between align-center">
        <v-btn
          color="error"
          icon
          @click="removeItem()">
          <v-icon>mdi-delete-outline</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-text-field
          v-model.number="innerAmount"
          class="number-field"
          color="secondary"
          style="max-width: 280px;"
          outlined
          dense
          min="1"
          hide-details
          prepend-inner-icon="mdi-minus"
          append-icon="mdi-plus"
          @click:prepend-inner="removeAmount()"
          @click:append="addAmount()" />
      </div>
    </v-col>
    <v-col
      v-else
      cols="12">
      <div class="d-flex flex-row justify-end align-center">
        <v-btn
          color="error"
          icon
          @click="removeItem()">
          <v-icon>mdi-delete-outline</v-icon>
        </v-btn>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import NoPicture from '@/assets/image/no_picture_available.png'
import { showPriceLocale } from '@/assets/js/Currencies'

export default {
  props: {
    aliasId: {
      type: Number,
      default: 0
    },
    name: {
      type: String,
      default: ''
    },
    code: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    },
    fitting: {
      type: String,
      default: ''
    },
    collection: {
      type: String,
      default: ''
    },
    images: {
      type: Array,
      default: () => []
    },
    price: {
      type: Number,
      default: 0
    },
    priceFromMapping: {
      type: Boolean,
      default: false
    },
    amount: {
      type: Number,
      default: 1
    },
    isShowFit: {
      type: Boolean,
      default: false
    },
    currencies: {
      type: Array,
      default: () => []
    },
    manufacCountry: {
      type: String,
      default: ''
    },
    isShowQty: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      noPicture: NoPicture,
      showPriceLocale
    }
  },
  computed: {
    innerAmount: {
      get () {
        return this.amount
      },
      set (val) {
        this.$emit('update:amount', val || 1)
      }
    }
  },
  methods: {
    addAmount () {
      this.innerAmount += 1
    },
    removeAmount () {
      if (this.innerAmount === 1) {
        return
      }

      this.innerAmount -= 1
    },
    removeItem () {
      this.$emit('remove-item')
    }
  }
}
</script>

<style scoped>
.bordered-table {
  border-collapse: collapse;
  width: 100%;
}
.bordered-table th,
.bordered-table td {
  border: 1px solid #ddd;
  padding: 8px;
}
.bordered-table th {
  background-color: #f5f5f5;
  font-weight: bold;
}
.bordered-row {
  border: 1px solid #ddd;   /* light border */
  border-radius: 4px;       /* optional rounded corners */
}
</style>
